var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"py-20"},[_c('v-icon',{attrs:{"color":"grey d-inline"}},[_vm._v("\n    mdi-tooltip-image\n  ")]),_c('div',{staticClass:"alert-color d-inline"},[_vm._v("\n    思い出を登録しましょう\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }